import { cn } from "@homeinstead/ui";

export type LeadFormWrapperProps = {
  className?: string;
  children: React.ReactNode;
  /**
   * Step-one hero variant. `buttonStack` sets `data-layout` so descendant
   * `group-data-[layout=buttonStack]/lead-form:` classes apply at md.
   */
  heroVariant?: string | null;
};

export function LeadFormWrapper({
  className,
  children,
  heroVariant,
}: LeadFormWrapperProps) {
  return (
    <div
      className={cn("group/lead-form", className)}
      data-layout={heroVariant || undefined}
    >
      {children}
    </div>
  );
}
